module.exports = __webpack_public_path__ + "img/login_bg.46113c2d.jpg";